<template>
	<v-flex>
		<v-card class="mt-4">
			<v-card-title>
                <h2>{{ navbarText }}</h2>
			</v-card-title>
			
			<contest-financial-settings-config v-if="itemIndexSelected==0" @changeConfig="changeConfig" :information="information" :informationShort="informationShort"  @loadInfo="loadInfo">

			</contest-financial-settings-config>
			<contest-financial-settings-config-for-module v-if="itemIndexSelected==1" @changeConfig="changeConfig" :information="information" :informationShort="informationShort" @loadInfo="loadInfo">

			</contest-financial-settings-config-for-module>
			<contest-financial-settings-config-for-module-percentage v-if="itemIndexSelected==2" @changeConfig="changeConfig" :information="information">

			</contest-financial-settings-config-for-module-percentage>
			

		</v-card>
	</v-flex>
</template>

<script>
	import ContestFinancialSettingsConfig from "./components/ContestFinancialSettingsConfig.vue";
	import ContestFinancialSettingsConfigForModule from "./components/ContestFinancialSettingsConfigForModule.vue";
	import ContestFinancialSettingsConfigForModulePercentage from "./components/ContestFinancialSettingsConfigForModulePercentage.vue";
	import {FinancialSettings} from "@/api/generated/FinancialSettings";

	export default {
		name: "ContestFinancialSettingsView",
		components: {
			ContestFinancialSettingsConfig,
			ContestFinancialSettingsConfigForModule,
			ContestFinancialSettingsConfigForModulePercentage
		},

		data() {
			return {
				itemIndexSelected: 0,
				information: "",
				informationShort: "",

			};
		},
		methods: {	
			changeConfig(changeTo){
				this.itemIndexSelected = changeTo;
			},
			loadInfo(){
				FinancialSettings.getModuleConfigured(this, this.$route.params.id, response => {
				let isAtLeastOneModubleConfigured = response;
				if(isAtLeastOneModubleConfigured){
					this.information = "Limity finansowe są określane odrębnie dla każdego modułu oferty. Moduł, w którym limity finansowe nie zostały określone przejmuje je z konfiguracji dla oferty. ";
					this.informationShort = "Limity finansowe w poszczególnych modułach są zróżnicowane";
				} else {
					this.information = "Limity finansowe zostają określone jednokrotnie dla całej oferty i są takie same w każdym module. W przypadku przełączania na konfigurację modułową stanowią wartość domyślną dla modułów, w których limity finansowe nie zostały określone.";
					this.informationShort = "Limity finansowe we wszystkich modułach są jednakowe";
				}
			});
			}
		},
		computed: {
            navbarText(){
                let description = "Limity finansowe";
                if(this.itemIndexSelected == 0){
                    description = description + " : " + "jednolite w całej ofercie";
                }else if(this.itemIndexSelected == 1){
                    description = description + " : " + "odrębne dla każdego modułu";
                }else if(this.itemIndexSelected == 2){
                    description = description + " : " + "relacje między modułami";
                }
                return description;
            }
        },

		mounted() {
			this.loadInfo();
		},

	};
</script>

<style scoped>

</style>
